import React from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Typography,
} from "@mui/material";

interface HelpModalProps {
    open: boolean;
    onClose: () => void;
}

const HelpModal: React.FC<HelpModalProps> = ({ open, onClose }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Audit</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" paragraph>
                    Audit groups events by <code>request_id</code>. Expand a row to
                    see the timeline of events for that request.
                </Typography>
                <Typography variant="body2" paragraph>
                    Root events are marked by <code>metadata.is_root=true</code> and
                    may contain <code>metadata.root_snapshot</code>.
                </Typography>
                <Typography variant="body2" paragraph>
                    CSV export uses the current URL filters (query string).
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={onClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default HelpModal;


